export const SHORTCUT_KEY = 'k';

export const MAC_SHORTCUT_LABEL = '⌘ K';
export const DEFAULT_SHORTCUT_LABEL = 'Ctrl K';
export const MAC_PLATFORM_PATTERN = /mac|iphone|ipad/i;

export const DIRECT_SECTION_LABEL = 'Main';
export const ALL_SECTIONS_LABEL = 'All';

export const KEYS = {
	ESCAPE: 'Escape',
	ARROW_DOWN: 'ArrowDown',
	ARROW_UP: 'ArrowUp',
	ENTER: 'Enter',
};

export const SEARCH_ICON = 'search';

export const COPY = {
	PLACEHOLDER: 'Search screens, descriptions or URLs...',
	NO_RESULTS: 'No results',
	BUTTON_LABEL: 'Search',
	ESCAPE_HINT: 'esc',
	ENTER_HINT: 'enter',
	NAVIGATE_HINT: 'navigate',
	OPEN_HINT: 'open',
	CLOSE_HINT: 'close',
	ARROW_UP: '↑',
	ARROW_DOWN: '↓',
};
